import React from "react";
import axios from "axios";
import Header from "../components/Header/Header";
import Content from "../components/Content/Content";
import { useSelector } from "react-redux";
import Modal from "../components/Modal/Modal";
import Footer from "../components/Footer/Footer";

function Korolev() {
  const NAV_MENU = [
    //{ id: "0", name: "Ассорти" },
    { id: "0", name: "Шашлык" },
    { id: "1", name: "Шаурма" },
    { id: "2", name: "Люля-кебаб" },
    { id: "3", name: "Рыба" },
    { id: "4", name: "Гарниры" },
    { id: "5", name: "Салаты" },
    { id: "6", name: "Выпечка" },
    { id: "7", name: "Соусы" },
    { id: "8", name: "Напитки" },
  ];
  const addressCity = {
    address: "Тюменский область, д.Дударева, ул. Тюменская д.20",
    dateTime: "с 11:00 до 22:00",
    phone: "+79220063339",
    city: "Дударева",
    BD: "dimShaslik",
  };
  const categoryId = useSelector((state) => state.filter.categoryId);
  const [items, setItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [cartIsVisible, setCartIsVisible] = React.useState(false);
  const [souse, setSouse] = React.useState([]);
  const body = document.body;

  React.useEffect(() => {
    if (cartIsVisible === true) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  }, [cartIsVisible]);

  React.useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        "https://6975ebf7c0c36a2a994fc4f4.mockapi.io/kavkaz_plennista/kavkaz_plennista?category=" +
          categoryId,
      )
      .then((arr) => {
        setItems(arr.data);
        setIsLoading(false);
      });
    axios
      .get("https://64cc1b8e2eafdcdc8519a858.mockapi.io/dimShaslik?category=8")
      .then((arr) => {
        setSouse(arr.data);
        setIsLoading(false);
      });
  }, [categoryId]);

  return (
    <>
      <Header open={() => setCartIsVisible(true)} addressCity={addressCity} />
      <Content
        navigation={NAV_MENU}
        item={items}
        isLoading={isLoading}
        addressCity={addressCity}
        souse={souse}
      />
      {cartIsVisible && (
        <Modal
          close={() => setCartIsVisible(false)}
          addressCity={addressCity}
        />
      )}
    </>
  );
}

export default Korolev;
